import logo from './../assets/images/logo.svg';
import icon from './../assets/images/icon.svg';
import loginBg from './../assets/images/login_bg.jpg';
import defaultImage from './../assets/images/default-image.png';
import defaultAvatar from './../assets/images/default_avatar.jpg';
import flagVi from './../assets/images/flag_square_vi.png';
import flagEn from './../assets/images/flag_square_en.png';
import flagKo from './../assets/images/flag_square_ko.png';
import flagCn from './../assets/images/flag_square_cn.png';
import flagRu from './../assets/images/flag_square_ru.svg';
import flagIndia from './../assets/images/flag_square_india.png';

export default {
    logo,
    icon,
    login_bg: loginBg,
    defaultImage,
    defaultAvatar,
    flag: {
        square: {
            vi: flagVi,
            en: flagEn,
            ko: flagKo,
            zh: flagCn,
            ru: flagRu,
            hi: flagIndia,
        },
    },
};
